<template>
  <v-textarea
    v-show="show"
    :label="label || title"
    v-model="val"
    :rules="rules"
    :required="required||false"
  ></v-textarea>
</template>

<script>
import {EventMixin} from '@/lib/mixins.js';

export default {
  mixins: [EventMixin],
  props: [
    'value',
    'name',
    'label',
    'title',
    'required'
  ],
  computed: {
    rules () {
      if(this.required) {
        return [
          v => !!v || this.label+' is required'
        ]
      }
      return [];
    },
    val: {
      get () {
        return _.get(this.value, this.name) || "";
      },
      set (val) {
        var value = _.cloneDeep(this.value);
        _.set(value, this.name, val);
        this.$emit("input", value);
      }
    }
  }
}
</script>
